import { useEffect, useState } from "react";
import api from "../../../../services/api"; // ajuste se necessário

function ClientesCard() {
  const [dados, setDados] = useState({
    clientes: 0,
    clientesativos: 0,
    clientesdesativados: 0
  });

  const [loading, setLoading] = useState(false);

  async function carregar() {
    setLoading(true);
    try {
      const response = await api.get("v1/dashboard/cliente", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setDados({
        clientes: response.data.clientes,
        clientesativos: response.data.clientesativos,
        clientesdesativados: response.data.clientesdesativados,
      });

    } catch (err) {
      console.log("Erro ao carregar clientes:", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    carregar();
  }, []);

  return (
    <div className="row g-3">

      {/* ==== CARD 1 – Total ==== */}
      <div className="col-12 col-md-4">
        <div className="dashboard-card">

          <div className="header-row">
            <div className="dashboard-header">
              <i className="fa fa-users"></i> Total de Clientes
            </div>
            <button className="btn btn-outline-primary btn-sm btn-refresh" onClick={carregar}>
              <i className="fa fa-sync"></i>
            </button>
          </div>

          <div className="dashboard-body">
            {loading ? <div>Carregando...</div> : <h2>{dados.clientes}</h2>}
          </div>
        </div>
      </div>

      {/* ==== CARD 2 – Ativos ==== */}
      <div className="col-12 col-md-4">
        <div className="dashboard-card">

          <div className="header-row">
            <div className="dashboard-header">
              <i className="fa fa-user-check"></i> Clientes Ativos
            </div>
            <button className="btn btn-outline-primary btn-sm btn-refresh" onClick={carregar}>
              <i className="fa fa-sync"></i>
            </button>
          </div>

          <div className="dashboard-body">
            {loading ? <div>Carregando...</div> : <h2>{dados.clientesativos}</h2>}
          </div>
        </div>
      </div>

      {/* ==== CARD 3 – Inativos ==== */}
      <div className="col-12 col-md-4">
        <div className="dashboard-card">

          <div className="header-row">
            <div className="dashboard-header">
              <i className="fa fa-user-times"></i> Clientes Inativos
            </div>
            <button className="btn btn-outline-primary btn-sm btn-refresh" onClick={carregar}>
              <i className="fa fa-sync"></i>
            </button>
          </div>

          <div className="dashboard-body">
            {loading ? <div>Carregando...</div> : <h2>{dados.clientesdesativados}</h2>}
          </div>
        </div>
      </div>

    </div>
  );
}

export default ClientesCard;
